/**
 * The Inbox's address, stated once (design 24, T17). Its own file, importing nothing, so the shell's
 * sidebar files (`features/shell/cabinet-attention.ts`, `nav-icons.ts`) can name it without
 * importing the screens behind it - a screen cannot import the shell's list
 * (`features/shell/in-app-navigation.ts` says why).
 *
 * The Inbox opens on its first tab, Comments. The two screens it holds keep their old addresses,
 * `/comments` and `/messages`, each opening its own tab (`features/cabinet/routes.ts`).
 */
export const INBOX_PATH = '/inbox';
